let html = `<div class="selectbox-item selector">
    <div class="selectbox-item__title">{title}</div>
    <div class="selectbox-item__subtitle">{subtitle}</div>
</div>`

export default html